'use client';

import type { i18n } from 'i18next';
import type { InsolvencyRecordItem } from '@/lib/backend-api';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { isoToGerman } from './companyDetailUtils';
import type { TFunction } from 'i18next';

interface InsolvencyStatusBadgeProps {
  i18n: i18n;
  insolvencyRecords: InsolvencyRecordItem[] | undefined;
  t: TFunction;
}

export function InsolvencyStatusBadge({
  i18n,
  insolvencyRecords,
  t,
}: InsolvencyStatusBadgeProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex items-center rounded-full bg-orange-500/10 border border-orange-500/30 px-1.5 py-0.5 font-medium text-orange-600 dark:text-orange-400 cursor-default">
            {i18n.language === 'de'
              ? 'Insolvenzverfahren'
              : 'Insolvency Proceedings'}
          </span>
        </TooltipTrigger>
        {insolvencyRecords && insolvencyRecords.length > 0 && (
          <TooltipContent side="bottom" className="text-xs">
            <div className="flex flex-col gap-0.5">
              {[...insolvencyRecords]
                .sort((a, b) =>
                  b.publish_date.localeCompare(a.publish_date),
                )
                .map((r, i) => (
                  <span key={i} className="flex gap-1.5">
                    <span className="tabular-nums shrink-0">
                      {isoToGerman(r.publish_date)}:
                    </span>
                    <span>
                      {t(
                        `companyHistory.insolvencyCategory.${r.category}`,
                        { defaultValue: r.category },
                      )}
                    </span>
                  </span>
                ))}
            </div>
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  );
}
